/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/require-default-props */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
import { ORIGINAL_VIDEO_LANGUAGE_OPTIONS } from '@src/config/languages';
import { useStore } from '@src/stores-v2/StoreContext';
import { useVideoCreatorStore } from '@src/stores-v2/VideoCreatorStoreContext';
import CheckIcon from '@src/svgs/CheckIcon';
import CheckIconAlt from '@src/svgs/CheckIconAlt';
import CreateIcon from '@src/svgs/CreateIcon';
import {
  buildSpeakersFromMappings,
  extractSpeakerLabelsFromTranscriptElements,
  fetchDatoSpeakers,
  fetchSpeakerVoiceMappings,
} from '@src/utility/speakerUtils';
import { useFlagsCombination } from '@src/utility/useFlagsCombination';
import { useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import styled, { css } from 'styled-components';

import AudienceFilterComponent from '../common/AudienceFilterComponent';
import AutoResizeableMultilineInput from '../common/AutoResizeableMultilineInput';
import GoalFilterComponent from '../common/GoalFilterComponent';
import ItemDropdownSelect from '../common/ItemDropdownSelect';
import Modal from '../common/Modal';
import SpeakerFilterComponent from '../common/SpeakerFilterComponent';

import type { AudienceOption } from '../common/AudienceSelector';
import type { GoalOption } from '../common/GoalSelector';
import type { Speaker } from './SpeakerTypes';
import type { AIPrompt } from '@src/types.ts/ai_prompts';

type Props = {
  title: string;
  templatesHeading?: string;
  templatesSublabel?: string;
  templates: AIPrompt[];
  allowBrandVoice?: boolean;
  customType?: 'Blog' | 'Social Post' | 'Email' | 'Quotes';
  customInstructionsLabel?: string;
  onClose: () => void;
  onConfirm: (
    template?: AIPrompt,
    brandVoice?: string,
    customInstructions?: string,
    avoidWords?: string,
    selectedSpeakers?: Speaker[],
    selectedGoal?: GoalOption | null,
    selectedAudiences?: AudienceOption[],
    selectedLanguage?: string,
  ) => void;
  confirmButtonLabel?: string;
  // Flag to enable speaker selection for pull quotes
  enableSpeakerSelection?: boolean;
};

function AIProducerModal(props: Props) {
  const {
    title,
    templatesHeading,
    templatesSublabel,
    templates,
    allowBrandVoice = true,
    customType,
    customInstructionsLabel = 'Customize your theme',
    onClose,
    onConfirm,
    confirmButtonLabel = 'Generate',
    enableSpeakerSelection = false,
  } = props;

  const { userIdentityStore } = useStore();
  const videoCreator = useVideoCreatorStore();
  const flags = useFlagsCombination(
    userIdentityStore.currentIdentity?.role as any,
  );

  // Check if transcript editor is enabled
  const isTranscriptEditorEnabled = flags.enableTranscriptEditor;
  const isAIContentLanguageSelectionEnabled =
    flags.contentStudioEnableAIContentLanguageSelection;

  const brandVoice = videoCreator.organization?.branding?.brandVoice;
  const avoidWords = videoCreator.organization?.branding?.avoidWords;
  const goals = videoCreator.organization?.branding?.goals || [];
  const audiences = videoCreator.organization?.branding?.audiences || [];
  const [selectedTemplate, setSelectedTemplate] = useState<AIPrompt | null>(
    null,
  );
  const [selectedGoal, setSelectedGoal] = useState<GoalOption | null>(null);
  const [useGoalFilter, setUseGoalFilter] = useState(false);
  const [selectedAudiences, setSelectedAudiences] = useState<AudienceOption[]>(
    [],
  );
  const [useAudienceFilter, setUseAudienceFilter] = useState(false);
  const handleSelectTemplate = (template: AIPrompt) => {
    setSelectedTemplate(prev => (prev?.id === template.id ? null : template));
  };

  const [shouldUseBrandVoice, setShouldUseBrandVoice] = useState(!!brandVoice);
  const [customInstructions, setCustomInstructions] = useState('');
  const handleChangeCustomInstructions = (value: string) => {
    setCustomInstructions(value);
  };

  // Speaker selection related state
  const [speakers, setSpeakers] = useState<Speaker[]>([]);
  const [selectedSpeakers, setSelectedSpeakers] = useState<Speaker[]>([]);
  const [isLoadingSpeakers, setIsLoadingSpeakers] = useState(false);
  const [useSpeakerFilter, setUseSpeakerFilter] = useState(false);
  const [useLanguageSelection, setUseLanguageSelection] = useState(false);
  const [language, setLanguage] = useState(
    videoCreator.rootStore?.transcriptionStore.language,
  );

  // Load speaker data when component mounts - only if transcript editor is enabled
  useEffect(() => {
    // Skip loading speakers if:
    // - speaker selection is disabled,
    // - no story ID,
    // - or transcript editor feature is disabled via LaunchDarkly flag
    if (
      !enableSpeakerSelection ||
      !videoCreator.story?.id ||
      !isTranscriptEditorEnabled
    )
      return;

    const loadSpeakers = async () => {
      setIsLoadingSpeakers(true);
      try {
        // Extract speaker labels from transcript
        const transcriptElements =
          videoCreator.rootStore?.transcriptionStore?.getFinalTranscriptionElements();
        const speakerLabels =
          extractSpeakerLabelsFromTranscriptElements(transcriptElements);

        if (speakerLabels.length === 0) {
          // No speakers found in transcript
          setIsLoadingSpeakers(false);
          return;
        }

        // Fetch mappings and Dato speakers
        const [speakerMappings, datoSpeakers] = await Promise.all([
          fetchSpeakerVoiceMappings(videoCreator.story!.id),
          fetchDatoSpeakers(
            videoCreator.story!.id,
            videoCreator.datoClientStore,
          ),
        ]);

        // Build the complete speaker list
        const speakerList = buildSpeakersFromMappings(
          speakerLabels,
          speakerMappings,
          datoSpeakers,
        );

        setSpeakers(speakerList);
        // Default to selecting all speakers
        setSelectedSpeakers(speakerList);
      } catch (error) {
        console.error('Error loading speaker data:', error);
      } finally {
        setIsLoadingSpeakers(false);
      }
    };

    loadSpeakers();
  }, [
    videoCreator.story?.id,
    enableSpeakerSelection,
    isTranscriptEditorEnabled,
  ]);

  // Disable brand voice when speaker filter is enabled
  useEffect(() => {
    if (useSpeakerFilter) {
      setShouldUseBrandVoice(false);
    }
  }, [useSpeakerFilter]);

  const handleConfirm = () => {
    onClose();
    onConfirm(
      selectedTemplate ?? undefined,
      allowBrandVoice && shouldUseBrandVoice ? brandVoice : undefined,
      (customType && customInstructions) || undefined,
      avoidWords,
      // Include speaker labels if filtering is in use (for any content type)
      useSpeakerFilter ? selectedSpeakers : undefined,
      useGoalFilter ? selectedGoal : undefined,
      useAudienceFilter && selectedAudiences.length > 0
        ? selectedAudiences
        : undefined,
      language,
    );
  };

  return (
    <Modal isOpen closeModal={onClose}>
      <Wrapper>
        <Content>
          <Title>{title}</Title>
          <Section>
            {templatesHeading && (
              <SectionHeading>{templatesHeading}</SectionHeading>
            )}
            {templatesSublabel && (
              <SectionSublabel>{templatesSublabel}</SectionSublabel>
            )}
            <OptionList>
              {templates.map(template => {
                const isSelected = selectedTemplate?.id === template.id;
                return (
                  <OptionItem
                    key={template.id}
                    selected={isSelected}
                    onClick={() => handleSelectTemplate(template)}
                  >
                    <div className="optionLabel">{template.title}</div>
                    {isSelected ? (
                      <div className="checkIcon">
                        <CheckIcon strokeColor="#4AD067" />
                      </div>
                    ) : (
                      <div className="checkEmpty" />
                    )}
                  </OptionItem>
                );
              })}
            </OptionList>
          </Section>

          {!!customType && (
            <Section>
              {customInstructionsLabel && (
                <SectionSublabel>{customInstructionsLabel}</SectionSublabel>
              )}
              <AutoResizeableMultilineInput
                disableAutoResize
                width="480px"
                fontSize="10px"
                placeholder={customInstructionsLabel}
                value={customInstructions}
                getValue={handleChangeCustomInstructions}
                customStyles={
                  customInstructions
                    ? { outline: '1px solid #f3e9d7' }
                    : undefined
                }
              />
            </Section>
          )}

          {/* Goal selection */}
          {goals.length > 0 && (
            <Section>
              <GoalFilterComponent
                goals={goals}
                align="left"
                selectedGoal={selectedGoal}
                setSelectedGoal={setSelectedGoal}
                useGoalFilter={useGoalFilter}
                setUseGoalFilter={setUseGoalFilter}
                allowNone
              />
            </Section>
          )}

          {/* Audience selection */}
          {audiences.length > 0 && (
            <Section>
              <AudienceFilterComponent
                align="left"
                audiences={audiences}
                selectedAudiences={selectedAudiences}
                setSelectedAudiences={setSelectedAudiences}
                useAudienceFilter={useAudienceFilter}
                setUseAudienceFilter={setUseAudienceFilter}
              />
            </Section>
          )}

          {/* Speaker selection for all supported content types - only show if transcript editor is enabled */}
          {isTranscriptEditorEnabled && speakers.length > 0 && (
            <Section>
              <SpeakerFilterComponent
                speakers={speakers}
                selectedSpeakers={selectedSpeakers}
                setSelectedSpeakers={setSelectedSpeakers}
                useSpeakerFilter={useSpeakerFilter}
                setUseSpeakerFilter={setUseSpeakerFilter}
                isLoadingSpeakers={isLoadingSpeakers}
                title="Filter by Speaker"
                align="left"
                infoText={
                  customType === 'Quotes'
                    ? 'Filter quotes to only include selected speakers'
                    : customType === 'Blog'
                      ? "Focus blog content on selected speakers' perspectives"
                      : customType === 'Social Post'
                        ? "Create posts highlighting selected speakers' key points"
                        : customType === 'Email'
                          ? "Frame email around selected speakers' insights"
                          : 'Focus content on selected speakers'
                }
              />
            </Section>
          )}

          {/* Brand voice option */}
          {allowBrandVoice ? (
            <Section>
              <CheckBoxContainer
                align={'left'}
                onClick={
                  brandVoice
                    ? () => setShouldUseBrandVoice(cur => !cur)
                    : undefined
                }
                disabled={!brandVoice}
                data-tooltip-id="brand-voice-tooltip"
                data-tooltip-content={
                  brandVoice
                    ? undefined
                    : 'Add your brand voice on the Brand Kit page'
                }
              >
                <CheckBox isChecked={shouldUseBrandVoice} role="button">
                  {shouldUseBrandVoice && <CheckIconAlt />}
                </CheckBox>
                <div className="checkbox-text">Use my Brand Voice</div>
              </CheckBoxContainer>
              <Tooltip
                id="brand-voice-tooltip"
                style={{
                  width: '150px',
                  color: '#f3e9d7',
                  textAlign: 'center',
                  padding: '8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  lineHeight: '120%',
                  zIndex: '10',
                }}
              />
            </Section>
          ) : null}

          {isAIContentLanguageSelectionEnabled && (
            <CheckBoxContainer
              align={'left'}
              onClick={() => setUseLanguageSelection(cur => !cur)}
            >
              <CheckBox isChecked={useLanguageSelection} role="button">
                {useLanguageSelection && <CheckIconAlt />}
              </CheckBox>
              <div className="checkbox-text">Select Language</div>
            </CheckBoxContainer>
          )}

          {useLanguageSelection && (
            <DropdownWrapper>
              <ItemDropdownSelect
                action={(_, value) => value && setLanguage(value)}
                propertyName="contentLanguage"
                defaultValue={language}
                values={ORIGINAL_VIDEO_LANGUAGE_OPTIONS}
              />
            </DropdownWrapper>
          )}

          <WriteButton
            disabled={
              (!selectedTemplate && !customInstructions) ||
              // Disable if speaker filtering is active but no speakers selected
              (enableSpeakerSelection &&
                useSpeakerFilter &&
                selectedSpeakers.length === 0)
            }
            onClick={handleConfirm}
          >
            <CreateIcon width="16" height="16" />
            {confirmButtonLabel}
          </WriteButton>
        </Content>
      </Wrapper>
    </Modal>
  );
}

const Wrapper = styled.div`
  border-radius: 10px;
  background-color: #03041a;
  width: 942px;
  border: 1px solid #484848;
`;

const Content = styled.div`
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 75px 0;
  background-color: #03041a;
`;

const Title = styled.h2`
  margin: 0;
  color: #f3e9d7;
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  align-self: center;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #484848;

  &:last-of-type {
    border-bottom: none;
  }
`;

const SectionHeading = styled.h3`
  margin: 0;
  color: #f3e9d7;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
`;

const SectionSublabel = styled.div`
  margin-bottom: -8px;
  color: #f3e9d7;
  font-size: 12px;
  line-height: 140%;
`;

const OptionList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

const OptionItem = styled.div<{ selected: boolean }>`
  display: flex;
  height: 32px;
  padding: 0 8px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 8px;
  border: 1px solid;
  border-color: ${({ selected }) => (selected ? '#F2D093' : '#5d5d5d')};
  background-color: ${({ selected }) => (selected ? '#F2D093' : 'transparent')};
  cursor: pointer;
  ${({ selected }) =>
    !selected &&
    css`
      &:hover {
        .optionLabel {
          color: #f2d093;
        }
      }
    `}
  .optionLabel {
    color: ${({ selected }) => (selected ? '#03041A' : '#9B9B9B')};
    font-size: 10px;
    font-weight: 500;
    line-height: 150%;
    transition: 150ms;
  }
  .checkEmpty {
    box-sizing: border-box;
    display: flex;
    width: 14px;
    height: 14px;
    padding: 2px;
    justify-content: center;
    align-items: center;
    border-radius: 80px;
    border: 1px solid #949494;
  }
  .checkIcon {
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4ad067;
    background: #03041a;
    border-radius: 14px;
  }
`;

const CheckBoxContainer = styled.div<{
  disabled?: boolean;
  align?: 'center' | 'left';
}>`
  display: flex;
  align-items: center;
  justify-content: ${props => props.align};
  gap: 8px;
  cursor: pointer;
  &,
  * {
    box-sizing: border-box;
  }
  .checkbox-text {
    color: #f3e9d7;
    font-size: 12px;
    line-height: 140%;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: default;
    `}
`;

const CheckBox = styled.div<{ isChecked: boolean }>`
  border: 0;
  outline: 0;
  background-color: ${props => (props.isChecked ? '#4AD067' : 'transparent')};
  width: 16px;
  height: 16px;
  border-radius: 2px;
  overflow: hidden;
  border: ${props => !props.isChecked && '1px solid #9B9B9B'};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WriteButton = styled.button`
  margin-top: 8px;
  display: flex;
  height: 48px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background: #17c964;
  border-radius: 8px;
  border: none;
  outline: none;
  cursor: pointer;
  color: #03041a;
  font-size: 14px;
  font-weight: 700;
  transition: 0.15s;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const DropdownWrapper = styled.div`
  color: #f3e9d7;
  .Selected {
    padding: 16px;
  }
`;

export default AIProducerModal;
